const API_HOST = 'https://api.vacancies.church'
const POSTING_COST = 5000
const PRE_LAUNCH = true;
module.exports = {
  API_HOST,
  POSTING_COST,
  PRE_LAUNCH
}

